<script>
  export let seeElement = true;
</script>

<button
  class="button_wrapper"
  on:click={() => {
    seeElement = !seeElement;
  }}
>
  <img
    src="/img/assistant/icons/chevron_down_dark.svg"
    alt="chevron_down"
    class="rotate"
    class:rotate-180={!seeElement}
  />
</button>

<style>
  .rotate-180 {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
  }

  .rotate {
    transition: transform 0.3s ease;
  }
</style>
